import config from './../config';

const getCookie = (c_name) => {
    let i, x, y, cookiesArray = document.cookie.split(";");
    for (i = 0; i < cookiesArray.length; i++) {
        x = cookiesArray[i].substr(0, cookiesArray[i].indexOf("="));
        y = cookiesArray[i].substr(cookiesArray[i].indexOf("=") + 1);
        x = x.replace(/^\s+|\s+$/g, "");
        if (x === c_name) {
            return (y);
        }
    }
};
const isTesting = getCookie('si_testing');
export const bustersConfig = {
    '/team-create': ['/team', '/gamercard/fetch', '/gamedays'],
    '/transfer': ['/team', '/gamercard/fetch', '/fixtures_{TourId}_{languageCode}_{matchdayId}.json'],
    '/booster': ['/team', '/gamercard/fetch'],
    '/substitution': ['/team', '/gamercard/fetch'],
    '/captain': ['/team', '/gamercard/fetch'],
    '/create': ['/leagues', '/home-leagues', '/leagueleaderboard', '/members', '/gamercard/fetch'],
    '/join': ['/leagues', '/home-leagues', '/leagueleaderboard', '/members', '/gamercard/fetch'],
    '/leave': ['/leagues', '/home-leagues', '/leagueleaderboard', '/members', '/gamercard/fetch'],
    '/relaunch': ['/leagues', '/home-leagues', '/leagueleaderboard', '/members', '/gamercard/fetch'],
    '/re-join': ['/leagues', '/home-leagues', '/leagueleaderboard', '/members', '/gamercard/fetch'],
    '/delete': ['/leagues', '/home-leagues', '/leagueleaderboard', '/members', '/gamercard/fetch'],
    '/prv-season-delete': ['/leagues', '/home-leagues', '/leagueleaderboard', '/members', '/gamercard/fetch'],
    '/prv-season-member-delete': ['/leagues', '/home-leagues', '/leagueleaderboard', '/members', '/gamercard/fetch'],
    '/suspend': ['/leagues', '/home-leagues', '/leagueleaderboard', '/members', '/gamercard/fetch'],
    '/removesuspension': ['/leagues', '/home-leagues', '/leagueleaderboard', '/members', '/gamercard/fetch'],
    '/league-name-update': ['/leagues', '/home-leagues', '/leagueleaderboard', '/members', '/gamercard/fetch'],
    '/user/update-team-name': ['/leagues', '/home-leagues', '/leagueleaderboard', '/members', '/gamercard/fetch'],
    '/subscribe': ['/gamercard/fetch', '/subscribe-info'],
    '/update-team-name': ['/subscribe-info'],
    '/bust-after-status-change': ['/team', '/gamercard/fetch', '/gamedays', '/constraints', '/fixtures_{TourId}_{languageCode}_{matchdayId}.json'],
    '/matchdetails': ['/matchdetails'],
    '/update-fav-team': ['/home-leagues']

};
let transAPI = config.API_FEEDS_PATH + 'feeds/translations/translations_{TourId}_{platformId}_{languageCode}.json';
// let transAPI = config.BASE_DIR + '/static/landing/{CLIENT_ID}/translations/{LANG}.json';
// transAPI = 'http://localhost:3000/trans.json';
export const translations = transAPI;
export const login = config.API_BASE_PATH + 'session/login';
export const saveTeam = config.API_BASE_PATH + 'gameplay/user/{GUID}/team-create';
export const userPlayedGameDays = config.API_BASE_PATH + 'gameplay/user/{GUID}/gamedays';
export const constraints = config.API_FEEDS_PATH + 'feeds/constraints/constraints_{TourId}.json';
export const rules = config.API_BASE_PATH + 'feed/rules';
export const formations = config.API_FEEDS_PATH + 'feeds/compositions/compositions_{TourId}_{gamedayId}.json';
export const teamNameValidationAPI = config.API_BASE_PATH + 'gameplay/user/validate-team-name';
export const fixtures = config.API_FEEDS_PATH + 'feeds/fixtures/fixtures_{TourId}_{languageCode}_{matchdayId}.json';
export const getTeam = config.API_BASE_PATH + 'gameplay/user/{GUID}/team';
export const playerListing = config.API_FEEDS_PATH + 'feeds/players/players_{TourId}_{languageCode}_{gamedayId}.json';
export const playerRecomendation = config.API_FEEDS_PATH + 'feeds/players/recommendation_{TourId}.json';
export const shareTeam = config.API_BASE_PATH + 'share/';
export const badgesAPI = config.API_FEEDS_PATH + 'feeds/badges/badges_{TourId}.json';
export const clubLeagues = config.API_FEEDS_PATH + 'feeds/teams/every_teams_{TourId}_{languageCode}.json';
export const playerCardAPI = config.API_FEEDS_PATH + 'feeds/popupstats/popupstats_{TourId}_{playerId}.json';
export const saveTransfersAPI = config.API_BASE_PATH + 'gameplay/user/{GUID}/transfer';
export const saveLimitlessAPI = config.API_BASE_PATH + 'gameplay/user/{GUID}/booster';
export const saveSubstitutionsAPI = config.API_BASE_PATH + 'gameplay/user/{GUID}/substitution';
export const saveCaptainAPI = config.API_BASE_PATH + 'gameplay/user/{GUID}/captain';
export const landingTrans = config.BASE_DIR + '/services/feeds/landing/translations/{clientName}/' + config.TourId + '_' + config.PLATFORM_ID + '_{lang}.json';

/** Home **/
export const gamerCardAPI = config.API_BASE_PATH + 'gameplay/gamercard/fetch';
export const eosUefacardAPI = config.API_BASE_PATH + 'gameplay/eos-uefacard/fetch';
let liveScoreAPIUrl = config.API_FEEDS_PATH + 'feeds/scoring/live-scores_{TourId}.json';
if (isTesting) {
    liveScoreAPIUrl = 'http://localhost:3000/scoring.json';
} else {
    liveScoreAPIUrl = config.API_FEEDS_PATH + 'feeds/scoring/live-scores_{TourId}.json';
}
export const liveScoreAPI = liveScoreAPIUrl;
// export const mixedAPI = config.API_BASE_PATH + 'live/mixed';
export const mixedAPI = config.API_FEEDS_PATH + 'feeds/live/mixed_{TourId}.json';

export const subscribeAPI = config.API_BASE_PATH + 'settings/user/subscribe';
export const editorialCardAPI = config.API_BASE_PATH + 'feed/news/article';
export const dreamTeamAPI = config.API_FEEDS_PATH + 'dreamteam/dreamteam_{TourId}_{languageCode}_{gamedayId}.json';
/** /Home **/
/** Leagues **/
export const getLeagues = config.API_BASE_PATH + 'leagues/{GUID}/user/leagues';
export const getPublicLeagues = config.API_BASE_PATH + 'leagues/{GUID}/user/home-leagues';
export const getLeagueLeaderBoard = config.API_BASE_PATH + 'leagues/{LEAGUE_ID}/leagueleaderboard';
export const getMembers = config.API_BASE_PATH + 'leagues/{LEAGUE_ID}/members';
const getOverAllLeaderBoard = config.API_FEEDS_PATH + 'feeds/leaderboards/{type}/';
const getOverAllLeaderBoardRank = config.API_BASE_PATH + 'leaderboard/{GUID}/rank';
const getCountryLeaderBoard = config.API_FEEDS_PATH + 'feeds/leaderboards/{type}/';
const getCountryLeaderBoardRank = config.API_BASE_PATH + 'leaderboard/country/{GUID}/{COUNTRY_ID}/rank';
const getFavouriteTeamLeaderBoard = config.API_FEEDS_PATH + 'feeds/leaderboards/{type}/';
const getFavouriteTeamLeaderBoardRank = config.API_BASE_PATH + 'leaderboard/team/{GUID}/{TEAM_ID}/rank';
const getKnockOutLeaderBoard = config.API_FEEDS_PATH + 'feeds/leaderboards/{type}/';
const getKnockOutLeaderBoardRank = config.API_BASE_PATH + 'leaderboard/{GUID}/knockout-rank';

export const publicLeaderBoard = {};
export const publicLeaderBoardRank = {};
publicLeaderBoard[config.publicLeaderBoardTypes.overall] = getOverAllLeaderBoard;
publicLeaderBoard[config.publicLeaderBoardTypes.country] = getCountryLeaderBoard;
publicLeaderBoard[config.publicLeaderBoardTypes.club] = getFavouriteTeamLeaderBoard;
publicLeaderBoard[config.publicLeaderBoardTypes.knockout] = getKnockOutLeaderBoard;
publicLeaderBoardRank[config.publicLeaderBoardTypes.overall] = getOverAllLeaderBoardRank;
publicLeaderBoardRank[config.publicLeaderBoardTypes.country] = getCountryLeaderBoardRank;
publicLeaderBoardRank[config.publicLeaderBoardTypes.club] = getFavouriteTeamLeaderBoardRank;
publicLeaderBoardRank[config.publicLeaderBoardTypes.knockout] = getKnockOutLeaderBoardRank;

export const postCreateLeague = config.API_BASE_PATH + 'leagues/{GUID}/create';
export const postJoinLeague = config.API_BASE_PATH + 'leagues/{GUID}/join';
export const postLeaveLeague = config.API_BASE_PATH + 'leagues/{GUID}/leave';
export const postRelaunchLeague = config.API_BASE_PATH + 'leagues/{GUID}/relaunch';
export const postReJoinLeague = config.API_BASE_PATH + 'leagues/{GUID}/re-join';
export const postDeleteLeague = config.API_BASE_PATH + 'leagues/{GUID}/delete';
export const postPreviousSeasonDeleteLeague = config.API_BASE_PATH + 'leagues/{GUID}/prv-season-delete';
export const postPreviousSeasonMemberDeleteLeague = config.API_BASE_PATH + 'leagues/{GUID}/prv-season-member-delete';
export const postSuspendLeague = config.API_BASE_PATH + 'leagues/{GUID}/suspend';
export const postRemoveSuspensionLeague = config.API_BASE_PATH + 'leagues/{GUID}/removesuspension';
export const updateLeagueName = config.API_BASE_PATH + 'leagues/{GUID}/league-name-update';
export const viewOtherUsersTeam = config.API_BASE_PATH + 'gameplay/user/{GUID}/user-team';
export const postFavTeam = config.API_BASE_PATH + 'gameplay/user/update-fav-team';
/** /Leagues **/
export const getSubscribeInfoAPI = config.API_BASE_PATH + 'settings/user/{GUID}/subscribe-info';
export const postUpdateTeamNameAPI = config.API_BASE_PATH + 'settings/user/update-team-name';
export const deleteFantasyTeamAPI = config.API_BASE_PATH + 'settings/user/delete-fantasy-team';
/** /match details **/
export const matchDetailsAPI = config.API_BASE_PATH + 'feed/matchdetails';
export const playerRecCategoryAPI = config.API_FEEDS_PATH + 'feeds/players/recommendation/players_{TourId}_{languageCode}_{gamedayId}_{category}.json'


// WEBPACK FOOTER //
// ./src/constants/api-url.js